import cn from 'clsx';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import QRCode from 'react-qr-code';
import toast from 'react-hot-toast';
import ic_link from '@images/link.png';
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from 'react-share';

import CopyLink from '@images/copyLinkRecentVoteIcon.svg';
import ButtonMighty from '@components/elements/ButtonMighty';
import {
  FacebookIcon,
  WhatsappIcon,
  LinkedinIcon,
} from '@components/elements/Icons';
import { useGlobalContext } from '@context/customContext';

interface PollShareCardProps
  extends Partial<React.PropsWithoutRef<HTMLDivElement>> {
  pollId: string;
  owner?: string;
  isIdea?: boolean;
  neon?: string;
}

const PollShareCard: React.FC<PollShareCardProps> = ({
  pollId,
  owner,
  className,
  isIdea,
  neon,
}) => {
  const { themeData } = useGlobalContext();

  const rootCn = cn('text-poll-shareCard-color py-8 px-6', className);
  const shareButtonCn =
    'flex justify-center p-2 w-10 h-10 rounded-full shadow-l-gray-darkest-sm';
  const imageCn = 'h-full max-w-full';

  const shareUrl = `${window.location.origin.toString()}/${
    isIdea ? 'idea' : 'poll'
  }/${pollId}`;

  return (
    <div className={rootCn}>
      <h2 className="mb-4 text-3xl" style={{ color: neon }}>
        Share
      </h2>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginBottom: '16px',
        }}
      >
        <div style={{ background: 'white', padding: '10px', width: '170px' }}>
          <QRCode value={shareUrl} size={150} />
        </div>
      </div>
      {/* <div className="mb-4">
        <CopyToClipboard
          text={shareUrl}
          onCopy={() => toast('Copied link to clipboard.')}
        >
          <div className="cursor-pointer " style={{ color: neon }}>
            COPY LINK
          </div>
         
        </CopyToClipboard>
      </div> */}
      <div
        className="flex  mb-4 space-x-6"
        style={{
          justifyContent: 'flex-start',
        }}
      >
        <FacebookShareButton url={shareUrl}>
          <div className={cn('bg-blue-light', shareButtonCn)}>
            <FacebookIcon className={imageCn} />
          </div>
        </FacebookShareButton>

        <WhatsappShareButton url={shareUrl}>
          <div className={cn('bg-green', shareButtonCn)}>
            <WhatsappIcon className={imageCn} />
          </div>
        </WhatsappShareButton>

        <LinkedinShareButton url={shareUrl}>
          <div className={cn('bg-cyan', shareButtonCn)}>
            <LinkedinIcon className={imageCn} />
          </div>
        </LinkedinShareButton>
        <CopyToClipboard
          text={shareUrl}
          onCopy={() => toast('Copied link to clipboard.')}
        >
          <div
            style={{ cursor: 'pointer' }}
            className="bg-red flex justify-center items-center p-2 w-10 h-10 rounded-full shadow-l-gray-darkest-sm"
          >
            <img src={ic_link} alt="" style={{ width: 20, height: 20 }} />
          </div>
        </CopyToClipboard>
      </div>

      {owner && <hr className="my-8" />}
      {owner && (
        <div className="flex justify-center text-center">
          Created by <br />
          {owner}
        </div>
      )}
    </div>
  );
};

export default PollShareCard;
